/**
 * The MIT License (MIT)
 * https://github.com/aurelia/dependency-injection
 *
 * Copyright (c) 2010 - 2018 Blue Spire Inc.
 */
function isAggregateError(error) {
    return !!error.innerError;
}
/**
 * Creates an instance of Error that aggregates and preserves an innerError.
 * @param message The error message.
 * @param innerError The inner error message to aggregate.
 * @param skipIfAlreadyAggregate Indicates to not wrap the inner error if it itself already has an innerError.
 * @return The Error instance.
 */
export function AggregateError(message, innerError, skipIfAlreadyAggregate) {
    // tslint:disable:no-parameter-reassignment
    if (innerError) {
        if (isAggregateError(innerError) && skipIfAlreadyAggregate) {
            return innerError;
        }
        const separator = '\n------------------------------------------------\n';
        message += `${separator}Inner Error:\n`;
        if (typeof innerError === 'string') {
            message += `Message: ${innerError}`;
        }
        else {
            if (innerError.message) {
                message += `Message: ${innerError.message}`;
            }
            else {
                message += `Unknown Inner Error Type. Displaying Inner Error as JSON:\n ${JSON.stringify(innerError, null, '  ')}`;
            }
            if (innerError.stack) {
                message += `\nInner Error Stack:\n${innerError.stack}`;
                message += '\nEnd Inner Error Stack';
            }
        }
        message += separator;
    }
    const e = new Error(message);
    if (innerError) {
        e.innerError = innerError;
    }
    return e;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWdncmVnYXRlRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJBZ2dyZWdhdGVFcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7R0FLRztBQUVILFNBQVMsZ0JBQWdCLENBQUMsS0FBVTtJQUNoQyxPQUFPLENBQUMsQ0FBQyxLQUFLLENBQUMsVUFBVSxDQUFDO0FBQzlCLENBQUM7QUFHRDs7Ozs7O0dBTUc7QUFDSCxNQUFNLFVBQVUsY0FBYyxDQUMxQixPQUFlLEVBQ2YsVUFBa0IsRUFDbEIsc0JBQWdDO0lBRWhDLDJDQUEyQztJQUMzQyxJQUFJLFVBQVUsRUFBRTtRQUNaLElBQUksZ0JBQWdCLENBQUMsVUFBVSxDQUFDLElBQUksc0JBQXNCLEVBQUU7WUFDeEQsT0FBTyxVQUFVLENBQUM7U0FDckI7UUFFRCxNQUFNLFNBQVMsR0FBRyxzREFBc0QsQ0FBQztRQUV6RSxPQUFPLElBQUksR0FBRyxTQUFTLGdCQUFnQixDQUFDO1FBRXhDLElBQUksT0FBTyxVQUFVLEtBQUssUUFBUSxFQUFFO1lBQ2hDLE9BQU8sSUFBSSxZQUFZLFVBQVUsRUFBRSxDQUFDO1NBQ3ZDO2FBQU07WUFDSCxJQUFJLFVBQVUsQ0FBQyxPQUFPLEVBQUU7Z0JBQ3BCLE9BQU8sSUFBSSxZQUFZLFVBQVUsQ0FBQyxPQUFPLEVBQUUsQ0FBQzthQUMvQztpQkFBTTtnQkFDSCxPQUFPLElBQUksK0RBQStELElBQUksQ0FBQyxTQUFTLENBQ3BGLFVBQVUsRUFDVixJQUFJLEVBQ0osSUFBSSxDQUNQLEVBQUUsQ0FBQzthQUNQO1lBRUQsSUFBSSxVQUFVLENBQUMsS0FBSyxFQUFFO2dCQUNsQixPQUFPLElBQUkseUJBQXlCLFVBQVUsQ0FBQyxLQUFLLEVBQUUsQ0FBQztnQkFDdkQsT0FBTyxJQUFJLHlCQUF5QixDQUFDO2FBQ3hDO1NBQ0o7UUFFRCxPQUFPLElBQUksU0FBUyxDQUFDO0tBQ3hCO0lBRUQsTUFBTSxDQUFDLEdBQUcsSUFBSSxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUM7SUFDN0IsSUFBSSxVQUFVLEVBQUU7UUFDWCxDQUFTLENBQUMsVUFBVSxHQUFHLFVBQVUsQ0FBQztLQUN0QztJQUVELE9BQU8sQ0FBQyxDQUFDO0FBQ2IsQ0FBQyJ9